export const HANDLE_INVALID = 'handle.invalid'
